import {
  TeamsMeetingsByOrganizerOfficeIdsClients_teamsMeetingsByOrganizerOfficeIds_edges as TeamsMeetingEdge,
  TeamsMeetingFields,
} from '@ms/yammer-graphql';

import { TeamsMeeting } from '../../../state/types';

import { getNodesFromEdges } from './edges';

export const processTeamsMeetingEdge: (edge: TeamsMeetingEdge) => TeamsMeeting = ({ node }) =>
  processTeamsMeeting(node);

export const processTeamsMeeting: (value: TeamsMeetingFields) => TeamsMeeting = (value) => ({
  ...value,
  startAt: new Date(value.startAt).getTime(),
  endAt: new Date(value.endAt).getTime(),
  organizers: getNodesFromEdges(value.organizers.edges).map((user) => user.id),
  moderators: getNodesFromEdges(value.moderators.edges).map((user) => user.id),
  creator: value.creator.id,
});
